import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { sidebar } from '../../constants';
import './MobileSideBar.scss';

export default function MobileSidebar() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>('personal-info');

  useEffect(() => {
    if (sidebar.sideBarPathList.includes(location.pathname)) {
      setActiveTab(location.pathname);
    }
  }, [location]);

  return (
    <div className="mobile-sidebar">
      <div className="mobile-sidebar-content-wrapper">
        {sidebar.list.map((item, index) => {
          const isSelected = activeTab === item.path;
          const Icon = item.icon;
          return (
            <Link to={item.path} className={`mobile-sidebar-link ${isSelected ? 'active' : ''}`} target={item.target} key={index}>
              <div className="mobile-sidebar-items">
                <Icon active={isSelected} />
                {item.name}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
}
